import {
    ALERT_MESSAGES_AND_REDIRECT_LINK,
    UNKNOWN_ERROR,
} from '../../domain/alert/alert.constants';

const addAxiosInstanceInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        response => response.data,
        (error) => {
            throw error.response.data;
        },
    );

    return axiosInstance;
};

const getApiErrorKeyByException = (exception) => {
    if (
        exception.response
        && exception.response.data
        && exception.response.data.errors
        && typeof exception.response.data.errors === 'object'
    ) {
        const apiErrorKey = Object.keys(exception.response.data.errors)[0];

        if (apiErrorKey) return apiErrorKey;
    }
    return UNKNOWN_ERROR;
};

export {
    addAxiosInstanceInterceptor,
    getApiErrorKeyByException,
};
